/** Primary/unified chat default subject from backend — hide in UI as redundant with page title. */
const DEFAULT_PRIMARY_SUBJECT_NORMALIZED = 'общий чат';

export function shouldShowSupportChatSubject(subject) {
  if (subject == null || !String(subject).trim()) return false;
  return String(subject).trim().toLowerCase() !== DEFAULT_PRIMARY_SUBJECT_NORMALIZED;
}
